"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _vue = require("vue");

var _xeUtils = _interopRequireDefault(require("xe-utils"));

var _tools = require("../../tools");

var _conf = _interopRequireDefault(require("../../v-x-e-table/src/conf"));

var _vXETable = require("../../v-x-e-table");

var _props = _interopRequireDefault(require("../../table/src/props"));

var _emits = _interopRequireDefault(require("../../table/src/emits"));

var _size = require("../../hooks/size");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function getOffsetHeight(elem) {
  return elem ? elem.offsetHeight : 0;
}

function getPaddingTopBottomSize(elem) {
  if (elem) {
    var computedStyle = getComputedStyle(elem);

    var paddingTop = _xeUtils.default.toNumber(computedStyle.paddingTop);

    var paddingBottom = _xeUtils.default.toNumber(computedStyle.paddingBottom);

    return paddingTop + paddingBottom;
  }

  return 0;
}

var tableComponentPropKeys = Object.keys(_props.default);
var tableComponentMethodKeys = ['clearAll', 'syncData', 'updateData', 'loadData', 'reloadData', 'reloadRow', 'loadColumn', 'reloadColumn', 'getRowNode', 'getColumnNode', 'getRowIndex', 'getVTRowIndex', 'getVMRowIndex', 'getColumnIndex', 'getVTColumnIndex', 'getVMColumnIndex', 'createData', 'createRow', 'revertData', 'clearData', 'isInsertByRow', 'isUpdateByRow', 'getColumns', 'getColumnById', 'getColumnByField', 'getTableColumn', 'getData', 'getCheckboxRecords', 'getRowById', 'getRowid', 'getTableData', 'hideColumn', 'showColumn', 'resetColumn', 'refreshColumn', 'refreshScroll', 'recalculate', 'closeTooltip', 'isAllCheckboxChecked', 'isCheckboxIndeterminate', 'getCheckboxIndeterminateRecords', 'setCheckboxRow', 'isCheckedByCheckboxRow', 'toggleCheckboxRow', 'setAllCheckboxRow', 'getRadioReserveRecord', 'clearRadioReserve', 'getCheckboxReserveRecords', 'clearCheckboxReserve', 'toggleAllCheckboxRow', 'clearCheckboxRow', 'setCurrentRow', 'isCheckedByRadioRow', 'setRadioRow', 'clearCurrentRow', 'clearRadioRow', 'getCurrentRecord', 'getRadioRecord', 'getCurrentColumn', 'setCurrentColumn', 'clearCurrentColumn', 'sort', 'clearSort', 'isSort', 'getSortColumns', 'closeFilter', 'isFilter', 'isRowExpandLoaded', 'clearRowExpandLoaded', 'reloadExpandContent', 'toggleRowExpand', 'setAllRowExpand', 'setRowExpand', 'isExpandByRow', 'clearRowExpand', 'clearRowExpandReserve', 'getRowExpandRecords', 'getTreeExpandRecords', 'isTreeExpandLoaded', 'clearTreeExpandLoaded', 'reloadTreeChilds', 'toggleTreeExpand', 'setAllTreeExpand', 'setTreeExpand', 'isTreeExpandByRow', 'clearTreeExpand', 'clearTreeExpandReserve', 'getScroll', 'scrollTo', 'scrollToRow', 'scrollToColumn', 'clearScroll', 'updateFooter', 'updateStatus', 'setMergeCells', 'removeMergeCells', 'getMergeCells', 'clearMergeCells', 'setMergeFooterItems', 'removeMergeFooterItems', 'getMergeFooterItems', 'clearMergeFooterItems', 'focus', 'blur', 'connect'];
var gridComponentEmits = [].concat(_toConsumableArray(_emits.default), ['page-change', 'form-submit', 'form-submit-invalid', 'form-reset', 'form-toggle-collapse', 'toolbar-button-click', 'zoom']);

var _default2 = (0, _vue.defineComponent)({
  name: 'VxeGrid',
  props: _objectSpread(_objectSpread({}, _props.default), {}, {
    columns: Array,
    pagerConfig: Object,
    proxyConfig: Object,
    toolbarConfig: Object,
    formConfig: Object,
    zoomConfig: Object,
    size: {
      type: String,
      default: function _default() {
        return _conf.default.grid.size || _conf.default.size;
      }
    }
  }),
  emits: gridComponentEmits,
  setup: function setup(props, context) {
    var slots = context.slots,
        emit = context.emit;

    var xID = _xeUtils.default.uniqueId();

    var instance = (0, _vue.getCurrentInstance)();
    var computeSize = (0, _size.useSize)(props);
    var reactData = (0, _vue.reactive)({
      tableLoading: false,
      proxyInited: false,
      isZMax: false,
      tableData: [],
      pendingRecords: [],
      filterData: [],
      formData: {},
      sortData: [],
      tZindex: 0,
      tablePage: {
        total: 0,
        pageSize: 10,
        currentPage: 1
      }
    });
    var refElem = (0, _vue.ref)();
    var refTable = (0, _vue.ref)();
    var refForm = (0, _vue.ref)();
    var refToolbar = (0, _vue.ref)();
    var refPager = (0, _vue.ref)();
    var refFormWrapper = (0, _vue.ref)();
    var refToolbarWrapper = (0, _vue.ref)();
    var refTopWrapper = (0, _vue.ref)();
    var refBottomWrapper = (0, _vue.ref)();
    var refPagerWrapper = (0, _vue.ref)();

    var extendTableMethods = function extendTableMethods(methodKeys) {
      var funcs = {};
      methodKeys.forEach(function (name) {
        funcs[name] = function () {
          var $xetable = refTable.value;
          return $xetable && $xetable[name].apply($xetable, arguments);
        };
      });
      return funcs;
    };

    var gridExtendTableMethods = extendTableMethods(tableComponentMethodKeys);
    tableComponentMethodKeys.forEach(function (name) {
      gridExtendTableMethods[name] = function () {
        var $xetable = refTable.value;
        return $xetable && $xetable[name].apply($xetable, arguments);
      };
    });
    var computeProxyOpts = (0, _vue.computed)(function () {
      return Object.assign({}, _conf.default.grid.proxyConfig, props.proxyConfig);
    });
    var computeIsMsg = (0, _vue.computed)(function () {
      var proxyOpts = computeProxyOpts.value;
      return proxyOpts.message !== false;
    });
    var computePagerOpts = (0, _vue.computed)(function () {
      return Object.assign({}, _conf.default.grid.pagerConfig, props.pagerConfig);
    });
    var computeFormOpts = (0, _vue.computed)(function () {
      return Object.assign({}, _conf.default.grid.formConfig, props.formConfig);
    });
    var computeToolbarOpts = (0, _vue.computed)(function () {
      return Object.assign({}, _conf.default.grid.toolbarConfig, props.toolbarConfig);
    });
    var computeZoomOpts = (0, _vue.computed)(function () {
      return Object.assign({}, _conf.default.grid.zoomConfig, props.zoomConfig);
    });
    var computeStyles = (0, _vue.computed)(function () {
      return reactData.isZMax ? {
        zIndex: reactData.tZindex
      } : null;
    });
    var computeTableExtendProps = (0, _vue.computed)(function () {
      var rest = {};
      var gridProps = props;
      tableComponentPropKeys.forEach(function (key) {
        rest[key] = gridProps[key];
      });
      return rest;
    });
    var refMaps = {
      refElem: refElem,
      refTable: refTable,
      refForm: refForm,
      refToolbar: refToolbar,
      refPager: refPager
    };
    var computeMaps = {
      computeProxyOpts: computeProxyOpts,
      computePagerOpts: computePagerOpts,
      computeFormOpts: computeFormOpts,
      computeToolbarOpts: computeToolbarOpts,
      computeZoomOpts: computeZoomOpts
    };
    var $xegrid = {
      xID: xID,
      props: props,
      context: context,
      instance: instance,
      reactData: reactData,
      getRefMaps: function getRefMaps() {
        return refMaps;
      },
      getComputeMaps: function getComputeMaps() {
        return computeMaps;
      }
    };
    var gridMethods = {};

    var handleRowClassName = function handleRowClassName(params) {
      var pendingRecords = reactData.pendingRecords;
      var rowClassName = props.rowClassName;
      var clss = [];

      if (pendingRecords.some(function (item) {
        return item === params.row;
      })) {
        clss.push('row--pending');
      }

      clss.push(rowClassName ? _xeUtils.default.isFunction(rowClassName) ? rowClassName(params) : rowClassName : '');
      return clss;
    };

    var handleActiveMethod = function handleActiveMethod(params) {
      var editConfig = props.editConfig;
      var pendingRecords = reactData.pendingRecords;
      var $xetable = refTable.value;
      var activeMethod = editConfig ? editConfig.activeMethod : null;
      return $xetable.findRowIndexOf(pendingRecords, params.row) === -1 && (!activeMethod || activeMethod(params));
    };

    var computeTableProps = (0, _vue.computed)(function () {
      var seqConfig = props.seqConfig,
          pagerConfig = props.pagerConfig,
          loading = props.loading,
          editConfig = props.editConfig,
          proxyConfig = props.proxyConfig;
      var isZMax = reactData.isZMax,
          tableLoading = reactData.tableLoading,
          tablePage = reactData.tablePage,
          tableData = reactData.tableData;
      var tableExtendProps = computeTableExtendProps.value;
      var proxyOpts = computeProxyOpts.value;
      var tableProps = Object.assign({}, tableExtendProps);

      if (isZMax) {
        if (tableExtendProps.maxHeight) {
          tableProps.maxHeight = 'auto';
        } else {
          tableProps.height = 'auto';
        }
      }

      if (proxyConfig) {
        tableProps.loading = loading || tableLoading;
        tableProps.data = tableData;
        tableProps.rowClassName = handleRowClassName;

        if (proxyOpts.seq && (0, _tools.isEnableConf)(pagerConfig)) {
          tableProps.seqConfig = Object.assign({}, seqConfig, {
            startIndex: (tablePage.currentPage - 1) * tablePage.pageSize
          });
        }
      }

      if (editConfig) {
        tableProps.editConfig = Object.assign({}, editConfig, {
          activeMethod: handleActiveMethod
        });
      }

      return tableProps;
    });
    var computePagerProps = (0, _vue.computed)(function () {
      var pagerOpts = computePagerOpts.value;
      return Object.assign({}, pagerOpts, props.proxyConfig ? reactData.tablePage : {});
    });

    var initToolbar = function initToolbar() {
      (0, _vue.nextTick)(function () {
        var $xetable = refTable.value;
        var $xetoolbar = refToolbar.value;

        if ($xetable && $xetoolbar) {
          $xetable.connect($xetoolbar);
        }
      });
    };

    var initPages = function initPages() {
      var pagerConfig = props.pagerConfig;
      var tablePage = reactData.tablePage;
      var pagerOpts = computePagerOpts.value;
      var currentPage = pagerOpts.currentPage,
          pageSize = pagerOpts.pageSize;

      if (pagerConfig) {
        if (currentPage) {
          tablePage.currentPage = currentPage;
        }

        if (pageSize) {
          tablePage.pageSize = pageSize;
        }
      }
    };

    var triggerPendingEvent = function triggerPendingEvent(code) {
      var pendingRecords = reactData.pendingRecords;
      var isMsg = computeIsMsg.value;
      var $xetable = refTable.value;
      var selectRecords = $xetable.getCheckboxRecords();

      if (selectRecords.length) {
        var plus = [];
        var minus = [];
        selectRecords.forEach(function (data) {
          if (pendingRecords.some(function (item) {
            return data === item;
          })) {
            minus.push(data);
          } else {
            plus.push(data);
          }
        });

        if (minus.length) {
          reactData.pendingRecords = pendingRecords.filter(function (item) {
            return $xetable.findRowIndexOf(minus, item) === -1;
          }).concat(plus);
        } else if (plus.length) {
          reactData.pendingRecords = pendingRecords.concat(plus);
        }

        gridExtendTableMethods.clearCheckboxRow();
      } else {
        if (isMsg) {
          _vXETable.VXETable.modal.message({
            id: code,
            message: _conf.default.i18n('vxe.grid.selectOneRecord'),
            status: 'warning'
          });
        }
      }
    };

    var getRespMsg = function getRespMsg(rest, defaultMsg) {
      var proxyOpts = computeProxyOpts.value;
      var _proxyOpts$props = proxyOpts.props,
          proxyProps = _proxyOpts$props === void 0 ? {} : _proxyOpts$props;
      var msg;

      if (rest && proxyProps.message) {
        msg = _xeUtils.default.get(rest, proxyProps.message);
      }

      return msg || _conf.default.i18n(defaultMsg);
    };

    var handleDeleteRow = function handleDeleteRow(code, alertKey, callback) {
      var isMsg = computeIsMsg.value;
      var selectRecords = gridExtendTableMethods.getCheckboxRecords();

      if (isMsg) {
        if (selectRecords.length) {
          return _vXETable.VXETable.modal.confirm({
            id: "cfm_".concat(code),
            message: _conf.default.i18n(alertKey),
            escClosable: true
          }).then(function (type) {
            if (type === 'confirm') {
              callback();
            }
          });
        } else {
          _vXETable.VXETable.modal.message({
            id: "msg_".concat(code),
            message: _conf.default.i18n('vxe.grid.selectOneRecord'),
            status: 'warning'
          });
        }
      } else {
        if (selectRecords.length) {
          callback();
        }
      }

      return Promise.resolve();
    };

    var pageChangeEvent = function pageChangeEvent(params) {
      var proxyConfig = props.proxyConfig;
      var tablePage = reactData.tablePage;
      var currentPage = params.currentPage,
          pageSize = params.pageSize;
      tablePage.currentPage = currentPage;
      tablePage.pageSize = pageSize;
      gridMethods.dispatchEvent('page-change', params);

      if (proxyConfig) {
        gridMethods.commitProxy('query');
      }
    };

    var sortChangeEvent = function sortChangeEvent(params) {
      var $xetable = refTable.value;
      var proxyConfig = props.proxyConfig;

      var _$xetable$getComputeM = $xetable.getComputeMaps(),
          computeSortOpts = _$xetable$getComputeM.computeSortOpts;

      var sortOpts = computeSortOpts.value; // 如果是服务端排序

      if (sortOpts.remote) {
        reactData.sortData = params.sortList;

        if (proxyConfig) {
          reactData.tablePage.currentPage = 1;
          gridMethods.commitProxy('query');
        }
      }

      gridMethods.dispatchEvent('sort-change', params);
    };

    var filterChangeEvent = function filterChangeEvent(params) {
      var $xetable = refTable.value;
      var proxyConfig = props.proxyConfig;

      var _$xetable$getComputeM2 = $xetable.getComputeMaps(),
          computeFilterOpts = _$xetable$getComputeM2.computeFilterOpts;

      var filterOpts = computeFilterOpts.value; // 如果是服务端过滤

      if (filterOpts.remote) {
        reactData.filterData = params.filterList;

        if (proxyConfig) {
          reactData.tablePage.currentPage = 1;
          gridMethods.commitProxy('query');
        }
      }

      gridMethods.dispatchEvent('filter-change', params);
    };

    var submitFormEvent = function submitFormEvent(params) {
      var proxyConfig = props.proxyConfig;

      if (proxyConfig) {
        gridMethods.commitProxy('reload');
      }

      gridMethods.dispatchEvent('form-submit', params);
    };

    var resetFormEvent = function resetFormEvent(params) {
      var proxyConfig = props.proxyConfig;

      if (proxyConfig) {
        gridMethods.commitProxy('reload');
      }

      gridMethods.dispatchEvent('form-reset', params);
    };

    var submitInvalidEvent = function submitInvalidEvent(params) {
      gridMethods.dispatchEvent('form-submit-invalid', params);
    };

    var togglCollapseEvent = function togglCollapseEvent(params) {
      (0, _vue.nextTick)(function () {
        return gridExtendTableMethods.recalculate(true);
      });
      gridMethods.dispatchEvent('form-toggle-collapse', params);
    };

    var handleZoom = function handleZoom(isMax) {
      var isZMax = reactData.isZMax;

      if (isMax ? !isZMax : isZMax) {
        reactData.isZMax = !isZMax;

        if (reactData.tZindex < _tools.UtilTools.getLastZIndex()) {
          reactData.tZindex = _tools.UtilTools.nextZIndex();
        }
      }

      return (0, _vue.nextTick)().then(function () {
        return gridExtendTableMethods.recalculate(true);
      }).then(function () {
        return reactData.isZMax;
      });
    };

    var getFuncSlot = function getFuncSlot(optSlots, slotKey) {
      var funcSlot = optSlots[slotKey];

      if (funcSlot) {
        if (_xeUtils.default.isString(funcSlot)) {
          if (slots[funcSlot]) {
            return slots[funcSlot];
          } else {
            if (process.env.NODE_ENV === 'development') {
              _tools.UtilTools.error('vxe.error.notSlot', [funcSlot]);
            }
          }
        } else {
          return funcSlot;
        }
      }

      return null;
    };
    /**
     * 渲染表单
     */


    var renderForms = function renderForms() {
      var formConfig = props.formConfig,
          proxyConfig = props.proxyConfig;
      var formData = reactData.formData;
      var proxyOpts = computeProxyOpts.value;
      var formOpts = computeFormOpts.value;
      var restVNs = [];

      if ((0, _tools.isEnableConf)(formConfig) || slots.form) {
        var slotVNs = [];

        if (slots.form) {
          slotVNs = slots.form({
            $grid: $xegrid
          });
        } else {
          if (formOpts.items) {
            if (!formOpts.inited) {
              formOpts.inited = true;
              var beforeItem = proxyOpts.beforeItem;

              if (proxyOpts && beforeItem) {
                formOpts.items.forEach(function (item) {
                  beforeItem({
                    $grid: $xegrid,
                    item: item
                  });
                });
              }
            }

            slotVNs.push((0, _vue.h)((0, _vue.resolveComponent)('vxe-form'), _objectSpread(_objectSpread({
              ref: refForm
            }, Object.assign({}, formOpts, {
              data: proxyConfig && proxyOpts.form ? formData : formOpts.data
            })), {}, {
              onSubmit: submitFormEvent,
              onReset: resetFormEvent,
              onSubmitInvalid: submitInvalidEvent,
              onToggleCollapse: togglCollapseEvent
            })));
          }
        }

        restVNs.push((0, _vue.h)('div', {
          ref: refFormWrapper,
          class: 'vxe-grid--form-wrapper'
        }, slotVNs));
      }

      return restVNs;
    };
    /**
     * 渲染工具栏
     */


    var renderToolbars = function renderToolbars() {
      var toolbarConfig = props.toolbarConfig;
      var toolbarOpts = computeToolbarOpts.value;
      var restVNs = [];

      if ((0, _tools.isEnableConf)(toolbarConfig) || slots.toolbar) {
        var slotVNs = [];

        if (slots.toolbar) {
          slotVNs = slots.toolbar({
            $grid: $xegrid
          });
        } else {
          var toolbarOptSlots = toolbarOpts.slots;
          var buttonsSlot;
          var toolsSlot;
          var toolbarSlots = {};

          if (toolbarOptSlots) {
            buttonsSlot = getFuncSlot(toolbarOptSlots, 'buttons');
            toolsSlot = getFuncSlot(toolbarOptSlots, 'tools');

            if (buttonsSlot) {
              toolbarSlots.buttons = buttonsSlot;
            }

            if (toolsSlot) {
              toolbarSlots.tools = toolsSlot;
            }
          }

          slotVNs.push((0, _vue.h)((0, _vue.resolveComponent)('vxe-toolbar'), _objectSpread({
            ref: refToolbar
          }, toolbarOpts), toolbarSlots));
        }

        restVNs.push((0, _vue.h)('div', {
          ref: refToolbarWrapper,
          class: 'vxe-grid--toolbar-wrapper'
        }, slotVNs));
      }

      return restVNs;
    };
    /**
     * 渲染表格顶部区域
     */


    var renderTops = function renderTops() {
      if (slots.top) {
        return [(0, _vue.h)('div', {
          ref: refTopWrapper,
          class: 'vxe-grid--top-wrapper'
        }, slots.top({
          $grid: $xegrid
        }))];
      }

      return [];
    };

    var tableCompEvents = {};

    _emits.default.forEach(function (name) {
      var type = _xeUtils.default.camelCase("on-".concat(name));

      tableCompEvents[type] = function () {
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return emit.apply(void 0, [name].concat(args));
      };
    });
    /**
     * 渲染表格
     */


    var renderTables = function renderTables() {
      var proxyConfig = props.proxyConfig;
      var tableProps = computeTableProps.value;
      var proxyOpts = computeProxyOpts.value;
      var tableOns = Object.assign({}, tableCompEvents);

      if (proxyConfig) {
        if (proxyOpts.sort) {
          tableOns.onSortChange = sortChangeEvent;
        }

        if (proxyOpts.filter) {
          tableOns.onFilterChange = filterChangeEvent;
        }
      }

      return [(0, _vue.h)((0, _vue.resolveComponent)('vxe-table'), _objectSpread(_objectSpread({
        ref: refTable
      }, tableProps), tableOns), {
        empty: function empty() {
          return slots.empty ? slots.empty({}) : [];
        }
      })];
    };
    /**
     * 渲染表格底部区域
     */


    var renderBottoms = function renderBottoms() {
      if (slots.bottom) {
        return [(0, _vue.h)('div', {
          ref: refBottomWrapper,
          class: 'vxe-grid--bottom-wrapper'
        }, slots.bottom({
          $grid: $xegrid
        }))];
      }

      return [];
    };
    /**
     * 渲染分页
     */


    var renderPagers = function renderPagers() {
      var pagerConfig = props.pagerConfig;
      var pagerProps = computePagerProps.value;
      var pagerOpts = computePagerOpts.value;
      var restVNs = [];

      if ((0, _tools.isEnableConf)(pagerConfig) || slots.pager) {
        var slotVNs = [];

        if (slots.pager) {
          slotVNs = slots.pager({
            $grid: $xegrid
          });
        } else {
          var pagerOptSlots = pagerOpts.slots;
          var pagerSlots = {};
          var leftSlot;
          var rightSlot;

          if (pagerOptSlots) {
            leftSlot = getFuncSlot(pagerOptSlots, 'left');
            rightSlot = getFuncSlot(pagerOptSlots, 'right');

            if (leftSlot) {
              pagerSlots.buttons = leftSlot;
            }

            if (rightSlot) {
              pagerSlots.tools = rightSlot;
            }
          }

          slotVNs.push((0, _vue.h)((0, _vue.resolveComponent)('vxe-pager'), _objectSpread(_objectSpread({
            ref: refPager
          }, pagerProps), {}, {
            onPageChange: pageChangeEvent
          }), pagerSlots));
        }

        restVNs.push((0, _vue.h)('div', {
          ref: refPagerWrapper,
          class: 'vxe-grid--pager-wrapper'
        }, slotVNs));
      }

      return restVNs;
    };

    var initProxy = function initProxy() {
      var proxyConfig = props.proxyConfig,
          formConfig = props.formConfig;
      var proxyInited = reactData.proxyInited;
      var proxyOpts = computeProxyOpts.value;
      var formOpts = computeFormOpts.value;

      if (proxyConfig) {
        if ((0, _tools.isEnableConf)(formConfig) && proxyOpts.form && formOpts.items) {
          var formData = {};
          formOpts.items.forEach(function (_ref) {
            var field = _ref.field,
                itemRender = _ref.itemRender;

            if (field) {
              formData[field] = itemRender && !_xeUtils.default.isUndefined(itemRender.defaultValue) ? itemRender.defaultValue : undefined;
            }
          });
          reactData.formData = formData;
        }

        if (!proxyInited && proxyOpts.autoLoad !== false) {
          reactData.proxyInited = true;
          (0, _vue.nextTick)(function () {
            return gridMethods.commitProxy('_init');
          });
        }
      }
    };

    gridMethods = {
      dispatchEvent: function dispatchEvent(type, params, evnt) {
        emit(type, Object.assign({
          $grid: $xegrid,
          $event: evnt
        }, params));
      },

      /**
       * 提交指令，支持 code 或 button
       * @param {String/Object} code 字符串或对象
       */
      commitProxy: function commitProxy(proxyTarget) {
        var toolbarConfig = props.toolbarConfig,
            pagerConfig = props.pagerConfig;
        var tablePage = reactData.tablePage,
            formData = reactData.formData;
        var isMsg = computeIsMsg.value;
        var proxyOpts = computeProxyOpts.value;
        var toolbarOpts = computeToolbarOpts.value;
        var beforeQuery = proxyOpts.beforeQuery,
            afterQuery = proxyOpts.afterQuery,
            beforeDelete = proxyOpts.beforeDelete,
            afterDelete = proxyOpts.afterDelete,
            beforeSave = proxyOpts.beforeSave,
            afterSave = proxyOpts.afterSave,
            _proxyOpts$ajax = proxyOpts.ajax,
            ajax = _proxyOpts$ajax === void 0 ? {} : _proxyOpts$ajax,
            _proxyOpts$props2 = proxyOpts.props,
            proxyProps = _proxyOpts$props2 === void 0 ? {} : _proxyOpts$props2;
        var $xetable = refTable.value;
        var button = null;
        var code = null;

        if (_xeUtils.default.isString(proxyTarget)) {
          var buttons = toolbarOpts.buttons;
          var matchObj = toolbarConfig && buttons ? _xeUtils.default.findTree(buttons, function (item) {
            return item.code === proxyTarget;
          }, {
            children: 'dropdowns'
          }) : null;
          button = matchObj ? matchObj.item : null;
          code = proxyTarget;
        } else {
          button = proxyTarget;
          code = button.code;
        }

        var btnParams = button ? button.params : null;

        for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
          args[_key2 - 1] = arguments[_key2];
        }

        switch (code) {
          case 'insert':
            $xetable.insert({});
            break;

          case 'insert_actived':
            $xetable.insert({}).then(function (_ref2) {
              var row = _ref2.row;
              return $xetable.setActiveRow(row);
            });
            break;

          case 'mark_cancel':
            triggerPendingEvent(code);
            break;

          case 'remove':
            return handleDeleteRow(code, 'vxe.grid.removeSelectRecord', function () {
              return $xetable.removeCheckboxRow();
            });

          case 'import':
            $xetable.importData(btnParams);
            break;

          case 'open_import':
            $xetable.openImport(btnParams);
            break;

          case 'export':
            $xetable.exportData(btnParams);
            break;

          case 'open_export':
            $xetable.openExport(btnParams);
            break;

          case 'reset_custom':
            $xetable.resetColumn(true);
            break;

          case '_init':
          case 'reload':
          case 'query':
            {
              var ajaxMethods = ajax.query;

              if (ajaxMethods) {
                var isInited = code === '_init';
                var isReload = code === 'reload';
                var sortList = [];
                var filterList = [];
                var pageParams = {};

                if (pagerConfig) {
                  if (isInited || isReload) {
                    tablePage.currentPage = 1;
                  }

                  if ((0, _tools.isEnableConf)(pagerConfig)) {
                    pageParams = _objectSpread({}, tablePage);
                  }
                }

                if (isInited) {
                  var _$xetable$getComputeM3 = $xetable.getComputeMaps(),
                      computeSortOpts = _$xetable$getComputeM3.computeSortOpts;

                  var sortOpts = computeSortOpts.value;
                  var defaultSort = sortOpts.defaultSort; // 如果使用默认排序

                  if (defaultSort) {
                    if (!_xeUtils.default.isArray(defaultSort)) {
                      defaultSort = [defaultSort];
                    }

                    sortList = defaultSort.map(function (item) {
                      return {
                        property: item.field,
                        order: item.order
                      };
                    });
                  }

                  filterList = $xetable.getCheckedFilters();
                } else {
                  if (isReload) {
                    reactData.pendingRecords = [];
                    $xetable.clearAll();
                  } else {
                    sortList = $xetable.getSortColumns();
                    filterList = $xetable.getCheckedFilters();
                  }
                }

                var params = {
                  code: code,
                  button: button,
                  $grid: $xegrid,
                  page: pageParams,
                  sort: sortList.length ? sortList[0] : {},
                  sorts: sortList,
                  filters: filterList,
                  form: formData,
                  options: ajaxMethods
                };
                reactData.sortData = sortList;
                reactData.filterData = filterList;
                reactData.tableLoading = true;
                var applyArgs = [params].concat(args);
                return Promise.resolve((beforeQuery || ajaxMethods).apply(void 0, _toConsumableArray(applyArgs))).catch(function (e) {
                  return e;
                }).then(function (rest) {
                  reactData.tableLoading = false;

                  if (rest) {
                    if ((0, _tools.isEnableConf)(pagerConfig)) {
                      var total = _xeUtils.default.get(rest, proxyProps.total || 'page.total') || 0;
                      tablePage.total = total;
                      reactData.tableData = _xeUtils.default.get(rest, proxyProps.result || 'result') || []; // 检验当前页码，不能超出当前最大页数

                      var pageCount = Math.max(Math.ceil(total / tablePage.pageSize), 1);

                      if (tablePage.currentPage > pageCount) {
                        tablePage.currentPage = pageCount;
                      }
                    } else {
                      reactData.tableData = (proxyProps.list ? _xeUtils.default.get(rest, proxyProps.list) : rest) || [];
                    }
                  } else {
                    reactData.tableData = [];
                  }

                  if (afterQuery) {
                    afterQuery.apply(void 0, _toConsumableArray(applyArgs));
                  }
                });
              } else {
                _tools.UtilTools.error('vxe.error.notFunc', ['query']);
              }

              break;
            }

          case 'delete':
            {
              var _ajaxMethods = ajax.delete;

              if (_ajaxMethods) {
                var removeRecords = gridExtendTableMethods.getCheckboxRecords();
                var body = {
                  removeRecords: removeRecords
                };

                var _applyArgs = [{
                  $grid: $xegrid,
                  code: code,
                  button: button,
                  body: body,
                  options: _ajaxMethods
                }].concat(args);

                if (removeRecords.length) {
                  return handleDeleteRow(code, 'vxe.grid.deleteSelectRecord', function () {
                    reactData.tableLoading = true;
                    return Promise.resolve((beforeDelete || _ajaxMethods).apply(void 0, _toConsumableArray(_applyArgs))).then(function (rest) {
                      reactData.tableLoading = false;
                      reactData.pendingRecords = reactData.pendingRecords.filter(function (row) {
                        return $xetable.findRowIndexOf(removeRecords, row) === -1;
                      });

                      if (isMsg) {
                        _vXETable.VXETable.modal.message({
                          message: getRespMsg(rest, 'vxe.grid.delSuccess'),
                          status: 'success'
                        });
                      }

                      if (afterDelete) {
                        afterDelete.apply(void 0, _toConsumableArray(_applyArgs));
                      } else {
                        gridMethods.commitProxy('query');
                      }
                    }).catch(function (rest) {
                      reactData.tableLoading = false;

                      if (isMsg) {
                        _vXETable.VXETable.modal.message({
                          id: code,
                          message: getRespMsg(rest, 'vxe.grid.operError'),
                          status: 'error'
                        });
                      }
                    });
                  });
                } else {
                  if (isMsg) {
                    _vXETable.VXETable.modal.message({
                      id: code,
                      message: _conf.default.i18n('vxe.grid.selectOneRecord'),
                      status: 'warning'
                    });
                  }
                }
              } else {
                _tools.UtilTools.error('vxe.error.notFunc', [code]);
              }

              break;
            }

          case 'save':
            {
              var _ajaxMethods2 = ajax.save;

              if (_ajaxMethods2) {
                var _body = Object.assign({
                  pendingRecords: reactData.pendingRecords
                }, $xetable.getRecordset());

                var insertRecords = _body.insertRecords,
                    _removeRecords = _body.removeRecords,
                    updateRecords = _body.updateRecords,
                    pendingRecords = _body.pendingRecords;

                var _applyArgs2 = [{
                  $grid: $xegrid,
                  code: code,
                  button: button,
                  body: _body,
                  options: _ajaxMethods2
                }].concat(args); // 排除掉新增且标记为删除的数据


                if (insertRecords.length) {
                  _body.pendingRecords = pendingRecords.filter(function (row) {
                    return $xetable.findRowIndexOf(insertRecords, row) === -1;
                  });
                } // 排除已标记为删除的数据


                if (pendingRecords.length) {
                  _body.insertRecords = insertRecords.filter(function (row) {
                    return $xetable.findRowIndexOf(pendingRecords, row) === -1;
                  });
                } // 只校验新增和修改的数据


                return $xetable.validate(_body.insertRecords.concat(updateRecords)).then(function () {
                  if (_body.insertRecords.length || _removeRecords.length || updateRecords.length || _body.pendingRecords.length) {
                    reactData.tableLoading = true;
                    return Promise.resolve((beforeSave || _ajaxMethods2).apply(void 0, _toConsumableArray(_applyArgs2))).then(function (rest) {
                      reactData.tableLoading = false;
                      reactData.pendingRecords = [];

                      if (isMsg) {
                        _vXETable.VXETable.modal.message({
                          message: getRespMsg(rest, 'vxe.grid.saveSuccess'),
                          status: 'success'
                        });
                      }

                      if (afterSave) {
                        afterSave.apply(void 0, _toConsumableArray(_applyArgs2));
                      } else {
                        gridMethods.commitProxy('query');
                      }
                    }).catch(function (rest) {
                      reactData.tableLoading = false;

                      if (isMsg) {
                        _vXETable.VXETable.modal.message({
                          id: code,
                          message: getRespMsg(rest, 'vxe.grid.operError'),
                          status: 'error'
                        });
                      }
                    });
                  } else {
                    if (isMsg) {
                      _vXETable.VXETable.modal.message({
                        id: code,
                        message: _conf.default.i18n('vxe.grid.dataUnchanged'),
                        status: 'info'
                      });
                    }
                  }
                }).catch(function (errMap) {
                  return errMap;
                });
              } else {
                _tools.UtilTools.error('vxe.error.notFunc', [code]);
              }

              break;
            }

          default:
            {
              var btnMethod = _vXETable.VXETable.commands.get(code);

              if (btnMethod) {
                btnMethod.apply(void 0, [{
                  code: code,
                  button: button,
                  $grid: $xegrid,
                  $table: $xetable
                }].concat(args));
              }
            }
        }

        return (0, _vue.nextTick)();
      },
      zoom: function zoom() {
        if (reactData.isZMax) {
          return gridMethods.revert();
        }

        return gridMethods.maximize();
      },
      isMaximized: function isMaximized() {
        return reactData.isZMax;
      },
      maximize: function maximize() {
        return handleZoom(true);
      },
      revert: function revert() {
        return handleZoom();
      },
      getFormItems: function getFormItems() {
        var formOpts = computeFormOpts.value;
        var formConfig = props.formConfig;
        var items = formOpts.items;
        return (0, _tools.isEnableConf)(formConfig) && items ? items : [];
      },
      getPendingRecords: function getPendingRecords() {
        return reactData.pendingRecords;
      },
      getProxyInfo: function getProxyInfo() {
        if (props.proxyConfig) {
          var sortData = reactData.sortData;
          return {
            data: reactData.tableData,
            filter: reactData.filterData,
            form: reactData.formData,
            sort: sortData.length ? sortData[0] : {},
            sorts: sortData,
            pager: reactData.tablePage,
            pendingRecords: reactData.pendingRecords
          };
        }

        return null;
      }
    }; // 检查插槽

    if (process.env.NODE_ENV === 'development') {
      gridMethods.loadColumn = function (columns) {
        var $xetable = refTable.value;

        _xeUtils.default.eachTree(columns, function (column) {
          if (column.slots) {
            _xeUtils.default.each(column.slots, function (func) {
              if (!_xeUtils.default.isFunction(func)) {
                if (!slots[func]) {
                  _tools.UtilTools.error('vxe.error.notSlot', [func]);
                }
              }
            });
          }
        });

        return $xetable.loadColumn(columns);
      };

      gridMethods.reloadColumn = function (columns) {
        gridExtendTableMethods.clearAll();
        return gridMethods.loadColumn(columns);
      };
    }

    var gridPrivateMethods = {
      extendTableMethods: extendTableMethods,
      callSlot: function callSlot(slotFunc, params) {
        if (slotFunc) {
          if (_xeUtils.default.isString(slotFunc)) {
            slotFunc = slots[slotFunc] || null;
          }

          if (_xeUtils.default.isFunction(slotFunc)) {
            return slotFunc(params);
          }
        }

        return [];
      },

      /**
       * 获取需要排除的高度
       */
      getExcludeHeight: function getExcludeHeight() {
        var height = props.height;
        var isZMax = reactData.isZMax;
        var el = refElem.value;
        var formWrapper = refFormWrapper.value;
        var toolbarWrapper = refToolbarWrapper.value;
        var topWrapper = refTopWrapper.value;
        var bottomWrapper = refBottomWrapper.value;
        var pagerWrapper = refPagerWrapper.value;
        var parentPaddingSize = isZMax || height !== 'auto' ? 0 : getPaddingTopBottomSize(el.parentNode);
        return parentPaddingSize + getPaddingTopBottomSize(el) + getOffsetHeight(formWrapper) + getOffsetHeight(toolbarWrapper) + getOffsetHeight(topWrapper) + getOffsetHeight(bottomWrapper) + getOffsetHeight(pagerWrapper);
      },
      getParentHeight: function getParentHeight() {
        var el = refElem.value;
        return (reactData.isZMax ? _tools.DomTools.getDomNode().visibleHeight : _xeUtils.default.toNumber(getComputedStyle(el.parentNode).height)) - gridPrivateMethods.getExcludeHeight();
      },
      triggerToolbarBtnEvent: function triggerToolbarBtnEvent(button, evnt) {
        gridMethods.commitProxy(button, evnt);
        gridMethods.dispatchEvent('toolbar-button-click', {
          code: button.code,
          button: button
        }, evnt);
      },
      triggerZoomEvent: function triggerZoomEvent(evnt) {
        gridMethods.zoom();
        gridMethods.dispatchEvent('zoom', {
          type: reactData.isZMax ? 'max' : 'revert'
        }, evnt);
      }
    };
    Object.assign($xegrid, gridExtendTableMethods, gridMethods, gridPrivateMethods);
    (0, _vue.watch)(function () {
      return props.columns;
    }, function (value) {
      (0, _vue.nextTick)(function () {
        return $xegrid.loadColumn(value || []);
      });
    });
    (0, _vue.watch)(function () {
      return props.toolbarConfig;
    }, function (value) {
      if (value) {
        initToolbar();
      }
    });
    (0, _vue.watch)(function () {
      return props.proxyConfig;
    }, function () {
      initProxy();
    });
    (0, _vue.watch)(function () {
      return props.pagerConfig;
    }, function () {
      initPages();
    });

    var handleGlobalKeydownEvent = function handleGlobalKeydownEvent(evnt) {
      var zoomOpts = computeZoomOpts.value;
      var isEsc = evnt.keyCode === 27;

      if (isEsc && reactData.isZMax && zoomOpts.escRestore !== false) {
        gridPrivateMethods.triggerZoomEvent(evnt);
      }
    };

    _vXETable.VXETable.hooks.forEach(function (options) {
      var setupGrid = options.setupGrid;

      if (setupGrid) {
        var hookRest = setupGrid($xegrid);

        if (hookRest && _xeUtils.default.isObject(hookRest)) {
          Object.assign($xegrid, hookRest);
        }
      }
    });

    (0, _vue.nextTick)(function () {
      var data = props.data,
          columns = props.columns,
          proxyConfig = props.proxyConfig;
      var proxyOpts = computeProxyOpts.value;
      var formOpts = computeFormOpts.value;

      if (proxyConfig && (data || proxyOpts.form && formOpts.data)) {
        _tools.UtilTools.error('errConflicts', ['grid.data', 'grid.proxy-config']);
      }

      if (columns && columns.length) {
        $xegrid.loadColumn(columns);
      }

      initToolbar();
      initPages();
      initProxy();

      _tools.GlobalEvent.on($xegrid, 'keydown', handleGlobalKeydownEvent);
    });
    (0, _vue.onUnmounted)(function () {
      _tools.GlobalEvent.off($xegrid, 'keydown');
    });

    var renderVN = function renderVN() {
      var _ref3;

      var vSize = computeSize.value;
      var styles = computeStyles.value;
      return (0, _vue.h)('div', {
        ref: refElem,
        class: ['vxe-grid', (_ref3 = {}, _defineProperty(_ref3, "size--".concat(vSize), vSize), _defineProperty(_ref3, 'is--animat', !!props.animat), _defineProperty(_ref3, 'is--round', props.round), _defineProperty(_ref3, 'is--maximize', reactData.isZMax), _defineProperty(_ref3, 'is--loading', props.loading || reactData.tableLoading), _ref3)],
        style: styles
      }, renderForms().concat(renderToolbars(), renderTops(), renderTables(), renderBottoms(), renderPagers()));
    };

    $xegrid.renderVN = renderVN;
    (0, _vue.provide)('$xegrid', $xegrid);
    return $xegrid;
  },
  render: function render() {
    return this.renderVN();
  }
});

exports.default = _default2;